import React from 'react';
import { InfinitySpin, LineWave } from 'react-loader-spinner';
import { Helmet } from 'react-helmet';

export default function Loading() {
  return (
    <div className="full-loading">
      <Helmet>
        <title>Loading... | Gsmart-IP</title>
      </Helmet>
      <LineWave
        type="ThreeDots"
        color="#87E990"
        height={150}
        width={150}
      />
    </div>
  );
}
